import styled from 'styled-components'

export const QueueContainer = styled.div`
  height: auto;
  max-height: 50vh;
  padding: 0 24px;

  @media (max-height: 500px) {
    max-height: 90vh;
  }
`

export const QueueSectionTitle = styled.h6`
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  color: ${({ theme }) => theme.colors.white0};
  margin-left: 8px;
`

export const QueueHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const QueueToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const QueueItemContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
  border-radius: 5px;
  padding: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralW30};
  }
`

export const CloseButton = styled.button`
  outline: none;
  margin-left: auto;
`
export const QueueItemTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  color: ${({ theme, isPlaying, isHighlighted }) =>
    isPlaying && isHighlighted
      ? theme.colors.player50
      : theme.colors.neutralW100};
  max-width: ${({ isPlaying }) => (isPlaying ? '135px' : '150px')};
`

export const QueueItemArtist = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
`
export const EmptyText = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  margin-top: 8px;
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.neutralW70};
`

export const QueueText = styled.p`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0em;
  color: ${({ theme }) => theme.colors.neutralW60};
  margin-top: 8px;
  margin-left: 8px;
  margin-bottom: 8px;
  text-transform: uppercase;
`
